import React from 'react';
import {Dialog, Form} from 'components/core';
import {FormField} from 'components/core/Form';
interface FormDialogProps
{
    onConfirm(values : {[key: string]: any}): void,
    onChange?(values : {[key: string]: any}): void,
    fields: FormField[],
    values?: {[key: string]: any},    
    loading: boolean,
    open: boolean,
    fieldErrors?:  {[key: string]: string},
    [props: string]: any
}
export default function FormDialog({onConfirm=()=>{}, onChange=()=>{}, fields = [], loading = false, values = undefined, open = false, fieldErrors = {}, ...props} : FormDialogProps)
{
    const [internalValues, setInternalValues] = React.useState({});
    const [errors, setErrors] = React.useState({});

    const useExternalValues = values !== undefined;
    const _values = values ? values : internalValues;

    React.useEffect(function SetFieldValues(){
        if(useExternalValues) return;

        let tmpValues : {[key: string]: any} = {};
        let update = false;
        
        fields.forEach((field) => {
            if(field.type !== "custom" || field.managed)
            {
                if(tmpValues[field.id] !== field.value)
                {
                    tmpValues[field.id] = field.value;
                    update = true;
                }
            }
        });
        if(update) setInternalValues(tmpValues);
    }, [fields, useExternalValues]);

    // React.useEffect(function setManagedValues(){
    //     if(useExternalValues) setInternalValues(values);
    // }, [useExternalValues, values]);

    React.useEffect(function cleanOnClose() {
        if(!open) setInternalValues({});
    }, [open]);

    const handleConfirm = () =>
    {
        let tmpErrors : {[key: string]: string} = {...fieldErrors};
        let errorsFound = Object.keys(fieldErrors).length > 0 ? true : false;
        fields.forEach((field) => {
            if(field.mandatory && !_values[field.id])
            {
                tmpErrors[field.id] = "Campo obligatorio";
                errorsFound = true;
            }
        });
        if(errorsFound || (!errorsFound && Object.keys(errors).length > 0)) setErrors(tmpErrors);
        if(!errorsFound)
        {
            onConfirm({..._values});
        }
    }


    function handleFormChange(newValues : any[])
    {
        if(!useExternalValues) setInternalValues({..._values, ...newValues});
        onChange({...newValues});
    }

    return <Dialog {...props} open={open} loading={loading} onConfirm={handleConfirm}>
        <Form fields={fields} loading={loading} fieldErrors={errors} onChange={(newValues : any[]) => handleFormChange(newValues)} values={_values}/>
    </Dialog>
}